import { faChevronRight, faFileLines } from '@fortawesome/pro-solid-svg-icons';
import { useMediaQuery, useTheme } from '@mui/material';
import { ChangeEvent, useState } from 'react';

import useTranslation from '../../hooks/useTranslation';
import Icon from '../Icon/Icon';
import ListField from '../ListField/ListField';
import DesktopUploadField from './DesktopUploadField';
import MobileUploadField from './MobileUploadField';

const UploadDocumentField = () => {
    const translate = useTranslation();
    const theme = useTheme();
    const greaterThanMid = useMediaQuery(theme.breakpoints.up('md'));
    const [open, setOpen] = useState(false);
    const [file, setFile] = useState<File | null>(null);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [_isUploadInProgress, setIsUploadInProgress] = useState<boolean>(false);
    const [_errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const files = event.target.files;
        if (files && files.length > 0) {
            setFile(files[0]);
        }
    };

    const removeFile = () => {
        setFile(null);
        setSelectedFile(null);
    };

    const onSelectFile = async (file: File) => {
        setSelectedFile(file);
        setIsUploadInProgress(true);
        setErrorMessage(undefined);

        //TODO: implement api call here to upload the document.
        //TODO: Add error handling as well on buttons, add don't close the dialog until the upload is successful
        setIsUploadInProgress(false);
    };

    return (
        <>
            <ListField
                name="uploadDocument"
                styling={true}
                items={[
                    {
                        index: '1',
                        label: !selectedFile ? translate('field.upload-document.label') : selectedFile.name,
                        subtitle: !selectedFile
                            ? translate('field.upload-document.subtitle.upload')
                            : translate('field.upload-document.subtitle.change'),
                        icon: selectedFile && <Icon icon={faFileLines} size="md" />,
                        endIcon: <Icon icon={faChevronRight} size="sm" color="secondary" />,
                    },
                ]}
                onClick={() => setOpen(true)}
            />
            {greaterThanMid ? (
                <DesktopUploadField
                    open={open}
                    setOpen={setOpen}
                    handleFileChange={handleFileChange}
                    onSelectFile={onSelectFile}
                    file={file}
                    selectedFile={selectedFile}
                    removeFile={removeFile}
                />
            ) : (
                <MobileUploadField
                    open={open}
                    setOpen={setOpen}
                    handleFileChange={handleFileChange}
                    onSelectFile={onSelectFile}
                    file={file}
                    selectedFile={selectedFile}
                    removeFile={removeFile}
                />
            )}
        </>
    );
};

export default UploadDocumentField;
